export default "__VITE_ASSET__BVD5IT8t__"